module.exports = __webpack_public_path__ + "img/map_0.c7d414db.webp";